// Local-storage keys + helpers for ChatWidget.
// Extracted from ChatWidget.jsx to shrink the widget component and
// make storage behavior unit-testable.

export const LS_CONV = "talkani_chat_conv_id";
export const LS_TOKEN = "talkani_chat_access_token";
export const LS_NAME = "talkani_chat_name";
export const LS_EMAIL = "talkani_chat_email";

// Stores a JSON array of teaser-keys already shown to this browser so each
// contextual message (autoteile, hausreinigung, book, …) fires exactly once
// per visitor instead of being suppressed forever by the first teaser shown.
export const LS_TEASER_SEEN_KEYS = "talkani_chat_teaser_seen_keys_v2";

export const readSeenKeys = () => {
  try {
    const raw = localStorage.getItem(LS_TEASER_SEEN_KEYS);
    if (!raw) return [];
    const parsed = JSON.parse(raw);
    return Array.isArray(parsed) ? parsed : [];
  } catch (_e) {
    return [];
  }
};

export const markKeySeen = (key) => {
  try {
    const list = readSeenKeys();
    if (!list.includes(key)) {
      list.push(key);
      localStorage.setItem(LS_TEASER_SEEN_KEYS, JSON.stringify(list));
    }
  } catch (_e) { /* private mode */ }
};

export const clearChatConversation = () => {
  try {
    localStorage.removeItem(LS_CONV);
    localStorage.removeItem(LS_TOKEN);
  } catch (_e) { /* private mode */ }
};

export const persistChatIdentity = (convId, token, name, email) => {
  try {
    localStorage.setItem(LS_CONV, convId);
    localStorage.setItem(LS_TOKEN, token);
    localStorage.setItem(LS_NAME, name);
    localStorage.setItem(LS_EMAIL, email);
  } catch (_e) { /* private mode */ }
};
